// extracted by mini-css-extract-plugin
export default {"container":"styles_container__bPvC1","main":"styles_main__fjxSD","noPadding":"styles_noPadding__8LG+I"};